let networkLink = {
    "file":"https://opdev-aion.plaync.com",
    "local":"https://opdev-aion.plaync.com",
    "op":"https://opdev-aion.plaync.com",
    "rc":"https://rc-aion.plaync.com",
    "live":"https://aion.plaync.com",
};

export default networkLink;